import {UserInfo} from "@kta20-core/models/auth/user-info";
import {IUserInfoAdapter} from "@kta20-core/interfaces/auth/i-user-info-adapter";
import {EventTarget} from "@kta20-core/core-module";

export interface IAuthBridge {

    getUserInfoAdapter():IUserInfoAdapter;

    serUserInfoAdapter(userInfoAdapter:IUserInfoAdapter);

    getToken(): string

    isUserAuthenticated(): Promise<boolean>;

    getUserInfo():Promise<UserInfo>;

     logout();

    addEventListener(type: any, listener: any | null, options?: boolean | EventTarget.AddOptions): void;
    removeEventListener(type: any, listener: any | null, options?: boolean | EventTarget.RemoveOptions): void;

}

export const I_AUTH_BRIDGE = 'IAuthBridge';